import { DataItem, Texto } from '@gravitate-js/excalibrr'
import moment from 'moment'
import React from 'react'
import { formatters } from '@utils/intl/dateTimeFormatters'

const sortMap = ['date', 'date_range', 'number', 'text']

const renderFieldValue = (field) => {
  switch (field.type) {
    case 'text':
    case 'number':
      return field.payload[field.type]
    case 'date':
      return formatters.DATE(moment(field.payload.date))
    case 'date_range':
      return `${formatters.DATE_TIME(moment(field.payload.from))} - ${formatters.DATE_TIME(moment(field.payload.to))}`
  }
}

export function ExtraFieldsExpand({ data }) {
  const extraFields = data?.extra_fields

  return (
    <div style={{ display: 'flex' }}>
      <div
        style={{
          backgroundColor: 'var(--gray-200)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '2rem',
        }}
      >
        <Texto appearance='medium' category='heading-small'>
          EXTRA FIELDS
        </Texto>
      </div>
      <div style={{ display: 'flex', gap: '2rem', padding: '1rem 3rem' }}>
        {sortMap
          .map((type) => extraFields.filter((item) => item.type === type && item.type !== 'photo'))
          .map((set) => set.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)))
          .reduce((acc, set) => [...acc, ...set], [])
          .map((item) => (
            <div key={item.name} style={{ marginBottom: 12 }}>
              <DataItem label={item.name}> {renderFieldValue(item)}</DataItem>
            </div>
          ))}
      </div>
    </div>
  )
}
